import { render, staticRenderFns } from "./Subtreatment.vue?vue&type=template&id=673ec808&scoped=true&"
import script from "./Subtreatment.vue?vue&type=script&lang=js&"
export * from "./Subtreatment.vue?vue&type=script&lang=js&"
import style0 from "./Subtreatment.vue?vue&type=style&index=0&id=673ec808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ec808",
  null
  
)

export default component.exports